enum NavPayloadAction {
  ViewVdp = 'view-vdp',
  ViewSrp = 'view-srp',
  ViewTrades = 'view-trade-offer',
  ViewFinancing = 'view-terms',
  ViewMyCars = 'view-my-cars'
}

export default NavPayloadAction;
